import {ConfigContext} from './config/context/index.js'
import Config, {APP_NAME_COCHES} from './config/index.js'
import Motor from './Motor.js'

/**
 *  Class representing Coches application
 *  @class
 */
class Coches extends Motor {
  /**
   * @constructor
   * @param {Object} deps
   * @param {String} deps.appName
   */
  constructor(logger) {
    const config = new Config({appName: APP_NAME_COCHES})

    ConfigContext.initialize(config)

    super({
      config,
      logger
    })
  }
}

/**
 * @exports default Coches
 */
export default Coches
